import Translate from "../../../translation/utils/translateFunction";

export const weekDays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const SELF = Translate("common:self"),
  OWNER = Translate("drawer:owner"),
  PA = Translate("common:personalAssistant"),
  GM = Translate("common:generalManager"),
  MANAGER = Translate("drawer:manager"),
  EMPLOYEE = Translate("drawer:employee"),
  VENDOR = Translate("filter:vendors_Suppliers"),
  HRMANAGER = Translate("common:hrmanager");

export const userTypeOptions = {
  SELF,
  OWNER,
  PA,
  GM,
  MANAGER,
  EMPLOYEE,
  VENDOR,
  HRMANAGER,
};

export const companyTypeOptions = [
  {
    label: "All",
    value: "All",
  },
  {
    label: "Project",
    value: "Project",
  },
  {
    label: "Independent task",
    value: "Task",
  },
];

export const companyType = ["Project", "Task", "Goal"];
